import styled from 'styled-components';
import { Flex } from '../Styled/flex.styled';

export const StyledCell = styled(Flex)`
  height: 100%;
  width: 100%;
`;
